import { defineStore } from 'pinia'
import { ref } from 'vue'
// The augmentation below needs `vue-router` in the program; a bare `declare module`
// does not pull it in when this file is checked from another project.
import type {} from 'vue-router'

export type PageHead = {
  titleKey?: string
  titleParams?: Record<string, unknown>
  title?: string
  description?: string
  robots?: string
}

declare module 'vue-router' {
  interface RouteMeta {
    head?: PageHead
  }
}

export const usePageHeadStore = defineStore('pageHead', () => {
  const head = ref<PageHead>({})

  const patch = (next: PageHead) => {
    head.value = { ...head.value, ...next }
  }

  const replace = (next: PageHead) => {
    head.value = next
  }

  return { head, patch, replace }
})
